import React from "react";
import { Select } from "antd";

// Ô lọc dạng chọn, option lấy từ GIÁ TRỊ CÓ THẬT trong DB (API filter-options).
//
// Lý do: trước đây option được hardcode ở FE nên lệch dữ liệu — dropdown "Loại
// lỗi" liệt kê 3 loại chưa từng tồn tại (NOTIFICATION/ATTRIBUTION/COMMISSION)
// và thiếu 3 loại đang có thật (EXCEPTION, COOKIE_ERROR, DATABASE_ERROR);
// Platform thiếu shopeefood. Lấy từ DB thì không bao giờ lệch nữa.
//
// values chưa tải xong (undefined) → vẫn cho gõ tự do nhờ showSearch.
function LogFilterSelect({ values, value, onChange, placeholder, width = 150 }) {
    return (
        <Select
            style={{ width }}
            allowClear
            showSearch
            placeholder={placeholder}
            value={value || undefined}
            onChange={(v) => onChange(v || "")}
            options={(values || []).map((v) => ({ value: v, label: v }))}
            filterOption={(input, opt) =>
                String(opt?.label || "").toLowerCase().includes(input.toLowerCase())
            }
        />
    );
}

export default LogFilterSelect;
